import { useState } from "react";
import {
    AppBar, Toolbar, Typography, useTheme, Collapse, Button,
    Tooltip, Drawer, List, IconButton, Divider, ListItem, ListItemIcon, ListItemText
} from "@mui/material";
import { makeStyles, createStyles } from '@mui/styles';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import IconExpandLess from '@mui/icons-material/ExpandLess'
import IconExpandMore from '@mui/icons-material/ExpandMore'
import SettingsIcon from '@mui/icons-material/Settings';
import clsx from "clsx";
import { connect } from "react-redux";
import * as authActions from "../../actions/user";
import { Link, withRouter } from "react-router-dom";
import Routes from "../../Routes";

const getMenuButtons = (headerButtons) => {
    return headerButtons.filter(v => v.visible).map(({ label, onClick }) => {
        return (
            <Button color="inherit" key={label} onClick={onClick} >
                {label}
            </Button>
        );
    });
};

const drawerWidth = 240;

const useStyles = makeStyles((theme) =>
    createStyles({
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        },
        appBarShift: {
            left: `${drawerWidth}px !important`,
            width: `calc(100% - ${drawerWidth}px) !important`,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        menuButton: {
            marginRight: 36,
        },
        hide: {
            display: 'none',
        },
        drawer: {
            width: `${drawerWidth}px`,
            flexShrink: 0,
            whiteSpace: 'nowrap',
        },
        drawerOpen: {
            width: `${drawerWidth}px`,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        drawerClose: {
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: 'hidden',
            zIndex: `${theme.zIndex.drawer - 202} !important`,
            width: theme.spacing(7),
            [theme.breakpoints.up('sm')]: {
                width: theme.spacing(9),
            },
        },
        toolbar: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: theme.spacing(0, 1),
            marginBottom: theme.spacing(2),
            // necessary for content to be below app bar
            ...theme.mixins.toolbar,
        },
    }),
);

const Header = (props) => {
    const classes = useStyles();
    const userObj = JSON.parse(localStorage.getItem('user'));
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const [expand, setExpand] = useState(false)
    const buttons = [
        {
            label: (userObj && userObj.user ? 'Hello, ' + userObj.user.firstName + ' ' + userObj.user.lastName : "Log In"),
            onClick: props.login,
            visible: true
        },
        { label: "Log Out", onClick: props.logout, visible: true }
    ];
    const isAdmin = (userObj && userObj.user && userObj.user.roleId === 1);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const onlineStoreLogo = (
        <Typography variant="h6" color="inherit" noWrap style={{ flex: 1 }}>
            {/* <img src="img\MC_LOGO.PNG" style={{ width: '100px', marginTop: '-30px', position: 'absolute'}} /> */}
            <span>Singapore CD LP Listing</span>
        </Typography>
    );

    function handleClick() {
        setExpand(!expand);
    }

    return (
        <>
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, { [classes.appBarShift]: open })}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        className={clsx(classes.menuButton, {
                            [classes.hide]: open,
                        })}
                    >
                        <MenuIcon />
                    </IconButton>
                    {onlineStoreLogo}
                    {getMenuButtons(buttons)}
                </Toolbar>
            </AppBar>
            <Drawer
                variant="permanent"
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                })}
                classes={{
                    paper: clsx({
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    }),
                }}
            >
                <div className={classes.toolbar}>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                    </IconButton>
                </div>
                <Divider />
                <List>
                    {Routes.filter(r => !r.isSettings)
                        .sort((a, b) => a.displayOrder - b.displayOrder)
                        .map((route, index) => (
                            <ListItem component={Link} to={route.path} key={route.path}>
                                <ListItemIcon>
                                    <Tooltip title={route.name}><route.icon /></Tooltip>
                                </ListItemIcon>
                                <ListItemText primary={route.name} />
                            </ListItem>
                        ))}
                </List>
                {isAdmin && <Divider />}
                {isAdmin && <List>
                    <ListItem button onClick={handleClick} key="Settings">
                        <ListItemIcon><Tooltip title="Settings"><SettingsIcon /></Tooltip></ListItemIcon>
                        <ListItemText primary="Settings" />
                        {expand ? <IconExpandLess /> : <IconExpandMore />}
                    </ListItem>
                    <Collapse in={expand} timeout="auto" unmountOnExit>
                        <Divider />
                        <List component="div" disablePadding>
                            {Routes.filter(r => r.isSettings)
                                .sort((a, b) => a.displayOrder - b.displayOrder)
                                .map((route, index) => (
                                    <ListItem component={Link} to={route.path} key={route.path}>
                                        <ListItemIcon>
                                            <Tooltip title={route.name}><route.icon /></Tooltip>
                                        </ListItemIcon>
                                        <ListItemText primary={route.name} />
                                    </ListItem>
                                ))}
                        </List>
                    </Collapse>
                </List>}
            </Drawer>
        </>
    );
}

const mapStateToProps = state => ({
})

const mapActionToProps = {
    logout: authActions.logout
}

export default withRouter(connect(mapStateToProps, mapActionToProps)(Header));